import { CalendarEventRef } from '@griply/types';
import { useQuery } from '@tanstack/react-query';
import { getExternalCalendarEvent } from 'shared/services/backend-api';

export const queryKey = 'external-calendar-event';

// `placeholderData` keeps the query out of the pending state that, under the global
// suspense default, would suspend the root-mounted EventFormProvider — and with it the
// whole app shell — behind the route's <Loading /> fallback. `isPlaceholderData` is what
// tells the popup a row is still loading; a resolved `null` means the event is gone.
export const useExternalCalendarEventQuery = (
  eventRef: CalendarEventRef | null,
) => {
  const query = useQuery({
    queryKey: [
      queryKey,
      eventRef?.connectionId,
      eventRef?.calendarId,
      eventRef?.eventId,
    ],
    queryFn: async () => getExternalCalendarEvent(eventRef!),
    enabled: !!eventRef,
    // the default is !!suspense — a throw would crash the route, not show the retry screen
    throwOnError: false,
    placeholderData: null,
    staleTime: 60 * 1000,
    gcTime: 60 * 1000,
  });

  return {
    ...query,
    details: query.isPlaceholderData ? undefined : query.data,
    isLoadingDetails: !!eventRef && query.isPlaceholderData,
  };
};
